module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$router.back()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Adicionar imóvel")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75164ab2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Headers/HeadersAdicionar.vue
// module id = 1030
// module chunks = 1